function setRegistrationStepSuccess({ state, input }) {
  let path = `client.registrating.current.${state.get('client.currentPage')}`
  input.result.errors.forEach(data => {
    if (data.value) {
      state.set(`${path}.${data.key}.value`, data.value)
    }
  })
}

export default setRegistrationStepSuccess



// WEBPACK FOOTER //
// ./src/modules/login/actions/setRegistrationStepSuccess.js